export class SaldoInventory {
  id: any;
  periodId: any;
  partnerId: any;
  status: any;
  logHistory: any;
}
